import React, { forwardRef } from 'react';
import { Select } from 'antd';
import { resolverUbicacion } from './useCiudadesTraslado';

// Ant Design muestra el valor crudo cuando no encuentra una opción. Nunca representar
// una selección excluida como si fuera una ubicación válida, incluso durante la carga.
const SelectUbicacionPermitida = forwardRef(({ value, options = [], onChange, ...props }, ref) => {
  const seleccion = resolverUbicacion(options.map(o => ({ id: o.value, nombre: o.label })), value);
  return <Select {...props} ref={ref} options={options} value={seleccion?.id}
    showSearch allowClear optionFilterProp="label"
    onChange={(nuevo, opcion) => {
      if (nuevo == null || options.some(o => o.value === nuevo)) onChange?.(nuevo, opcion);
    }} />;
});
export default SelectUbicacionPermitida;
